export default `
§ page.settings.document.title: Настройки отображения
§ page.settings.document.name: Заголовок страницы
§ page.settings.document.language: Язык интерфейса
§ page.settings.document.depersonalize: Скрыть персональные данные
§ page.settings.links.title: Префиксы ссылок
§ page.settings.links.task: Для номеров задач
§ page.settings.links.pr: Для PR
§ page.settings.user.title: Индивидуальные настройки
§ page.settings.user.notFound: Индивидуальных настроек нет. Данные по всем сотрудникам вычисляются по общим параметрам.
§ page.settings.user.subTitle: Дополнение к трудовому договору №$1
§ page.settings.user.from: Дата начала действия
§ page.settings.mailmap: Настройки .mailmap
§ page.settings.common.title: Общие данные по зарплате
§ page.settings.common.type.title: Тип работы над проектом
§ page.settings.common.type.full: Полная занятость
§ page.settings.common.type.part: Проектная работа
§ page.settings.common.salary: Зарплата в месяц в долларах США
§ page.settings.common.currency: Валюта для отображения
§ page.settings.common.workDaysInYear: Количество рабочих дней в году
§ page.settings.common.vacationDaysInYear: Количество дней отпуска в год
§ page.settings.common.workDaysInWeek: Рабочие дни
§ page.settings.form.save: Сохранить
§ page.settings.form.cancel: Отмена
§ page.settings.form.remove: Удалить
§ page.settings.form.addEmployee: Добавить сотрудника
§ page.settings.form.addContract: Добавить трудовой договор
`;
